import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Contact } from './pages/Contact';
import { Blog } from './pages/Blog';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <motion.div key={location.pathname} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.4
    }} data-id="element-1">
        <Routes location={location} data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<About data-id="element-6" />} data-id="element-5" />
          <Route path="/services" element={<Services data-id="element-8" />} data-id="element-7" />
          <Route path="/contact" element={<Contact data-id="element-10" />} data-id="element-9" />
          <Route path="/programs" element={<Services data-id="element-12" />} data-id="element-11" />
          <Route path="/blog" element={<Blog data-id="element-14" />} data-id="element-13" />
        </Routes>
      </motion.div>
    </AnimatePresence>;
}
export function App() {
  return <Router data-id="element-15">
      <div className="min-h-screen flex flex-col" data-id="element-16">
        <ScrollToTop data-id="element-17" />
        <Navbar data-id="element-18" />
        <AnimatedRoutes data-id="element-19" />
        <Footer data-id="element-20" />
      </div>
    </Router>;
}